import { handleApiError } from './api-error-handler'

/**
 * Makes API calls with error handling and token refresh capabilities.
 *
 * @param apiFunction The API function to call
 * @param rejectWithValue Optional Redux Toolkit rejectWithValue function
 * @param params Parameters to pass to the API function
 * @returns The result of the API call
 */
export const apiCall = async function <T, Args extends any[]>(
  apiFunction: (...args: Args) => Promise<T>,
  rejectWithValue: Function | null,
  ...params: Args
): Promise<T> {
  try {
    return await apiFunction(...params)
  } catch (error) {
    return handleApiError(error, apiFunction, params, rejectWithValue)
  }
}
